export const renderMoment = ({ formatType = 'YYYY-MM-DD', utcDateString, options = {} }) => {
  if (!utcDateString) return null

  if (typeof utcDateString === 'number') {
    utcDateString = new Date(utcDateString).toISOString()
  }

  const {
    seconds = true,
    hourFormat = '24', // '12' | '24'
    displayMode = 'LOCAL', // 'UTC' | 'LOCAL'
  } = options

  let dateString = utcDateString

  // 🛠 Normalize input to valid UTC
  if (dateString.includes('T') && !dateString.includes('Z') && !dateString.includes('+')) {
    dateString = dateString + 'Z'
  }
  // If space-separated format, append UTC
  else if (!dateString.includes('T')) {
    dateString = dateString + ' UTC'
  }

  const dateObj = new Date(dateString)

  if (isNaN(dateObj.getTime())) return null

  // 🎯 Choose getters based on mode
  const getters =
    displayMode === 'UTC'
      ? {
          year: dateObj.getUTCFullYear(),
          month: dateObj.getUTCMonth() + 1,
          day: dateObj.getUTCDate(),
          hour: dateObj.getUTCHours(),
          minute: dateObj.getUTCMinutes(),
          second: dateObj.getUTCSeconds(),
        }
      : {
          year: dateObj.getFullYear(),
          month: dateObj.getMonth() + 1,
          day: dateObj.getDate(),
          hour: dateObj.getHours(),
          minute: dateObj.getMinutes(),
          second: dateObj.getSeconds(),
        }

  const pad = (num) => String(num).padStart(2, '0')

  const MONTHS_SHORT = [
    'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
    'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC',
  ]

  // 📅 Date formatting (always "-" divider)
  let formattedDate

  switch (formatType) {
    case 'DD-MM-YYYY':
      formattedDate = `${pad(getters.day)}-${pad(getters.month)}-${getters.year}`
      break

    case 'MM-DD-YYYY':
      formattedDate = `${pad(getters.month)}-${pad(getters.day)}-${getters.year}`
      break

    case 'YYYY-DD-MM':
      formattedDate = `${getters.year}-${pad(getters.day)}-${pad(getters.month)}`
      break

    // e.g. "21 JUL 2026" — day, short month name, year (space divider)
    case 'DD MMM YYYY':
      formattedDate = `${pad(getters.day)} ${MONTHS_SHORT[getters.month - 1]} ${getters.year}`
      break

    case 'YYYY-MM-DD':
    default:
      formattedDate = `${getters.year}-${pad(getters.month)}-${pad(getters.day)}`
  }

  // 🕒 Time formatting
  let hour = getters.hour
  let postfix = ''

  if (hourFormat === '12') {
    postfix = hour >= 12 ? 'PM' : 'AM'
    hour = hour % 12 || 12
  }

  const formattedTime = seconds
    ? `${pad(hour)}:${pad(getters.minute)}:${pad(getters.second)}`
    : `${pad(hour)}:${pad(getters.minute)}`

  return {
    date: formattedDate,
    time: formattedTime,
    timePostfix: hourFormat === '12' ? postfix : '',
  }
}
